var map = {
	"./TipTapImage": 11686,
	"./TipTapImage.js": 11686,
	"./animation-loader-white.gif": 31497,
	"./animation-loader-white.svg": 70109,
	"./animation-loader.gif": 92886,
	"./animation-loader.svg": 16108,
	"./attribute-gradient-blue.svg": 53713,
	"./attribute.eot": 29830,
	"./attribute.svg": 23169,
	"./attribute.ttf": 30343,
	"./attribute.woff": 54029,
	"./color-palette": 23525,
	"./color-palette.json": 23525,
	"./config/intervals": 85256,
	"./config/intervals.json": 85256,
	"./data-defaultIntegrations": 5212,
	"./data-defaultIntegrations.json": 5212,
	"./data-defaultNotifications": 75044,
	"./data-defaultNotifications.json": 75044,
	"./data-defaultNotificationsConfig": 26410,
	"./data-defaultNotificationsConfig.json": 26410,
	"./data-onboardingSteps": 46022,
	"./data-onboardingSteps.json": 46022,
	"./data-plans": 58259,
	"./data-plans.json": 58259,
	"./data-supportArticles": 11513,
	"./data-supportArticles.json": 11513,
	"./favicon/android-chrome-192x192.png": 22230,
	"./favicon/android-chrome-512x512.png": 22367,
	"./favicon/apple-touch-icon.png": 75454,
	"./favicon/favicon-16x16.png": 80603,
	"./favicon/favicon-32x32.png": 19488,
	"./favicon/favicon.ico": 25080,
	"./favicon/site.webmanifest": 44870,
	"./homepage/dotted-circles.png": 85349,
	"./homepage/dotted-circles.svg": 90943,
	"./homepage/elements-reports-design.svg": 45381,
	"./homepage/gradient-2.svg": 17959,
	"./homepage/gradient-4.svg": 2846,
	"./homepage/screenshot-database.svg": 9562,
	"./homepage/screenshot-reports.png": 86134,
	"./homepage/screenshot-survey.png": 56653,
	"./homepage/screenshot-survey.svg": 25381,
	"./icon-account.svg": 58958,
	"./icon-arrow-right.svg": 29782,
	"./icon-attribute-1200x1200.png": 6202,
	"./icon-attribute-web.png": 5274,
	"./icon-attribute-white.svg": 83970,
	"./icon-attribute.png": 62679,
	"./icon-attribute.svg": 22913,
	"./icon-check-circle.svg": 9681,
	"./icon-check.svg": 60199,
	"./icon-chevron-down.svg": 97986,
	"./icon-chevron-left.svg": 35261,
	"./icon-chevron-right.svg": 48230,
	"./icon-chevron-up.svg": 56447,
	"./icon-copy.svg": 41035,
	"./icon-cross.svg": 2874,
	"./icon-curly-brackets.svg": 14813,
	"./icon-database.svg": 67119,
	"./icon-design.svg": 77530,
	"./icon-download.svg": 4596,
	"./icon-email.svg": 3328,
	"./icon-home.png": 64426,
	"./icon-home.svg": 59395,
	"./icon-info.svg": 4369,
	"./icon-installation.svg": 42664,
	"./icon-integrations.svg": 50170,
	"./icon-lifesaver.svg": 66890,
	"./icon-minus.svg": 26736,
	"./icon-plus.svg": 61179,
	"./icon-reports.svg": 86611,
	"./icon-triangle-down.svg": 56063,
	"./icons/Vector (Stroke)-icon-1.svg": 91057,
	"./icons/Vector (Stroke)-icon-2.svg": 86026,
	"./icons/Vector (Stroke)-icon-3.svg": 75789,
	"./icons/Vector (Stroke)-icon-4.svg": 85366,
	"./icons/Vector (Stroke)-icon.svg": 74276,
	"./icons/activity-icon.svg": 25953,
	"./icons/airplay-icon.svg": 65791,
	"./icons/alert-circle-icon.svg": 42437,
	"./icons/alert-octagon-icon.svg": 1729,
	"./icons/alert-triangle-icon.svg": 27702,
	"./icons/align-center-icon.svg": 13529,
	"./icons/align-justify-icon.svg": 94337,
	"./icons/align-left-icon.svg": 20328,
	"./icons/align-right-icon.svg": 80477,
	"./icons/anchor-icon.svg": 26697,
	"./icons/aperture-icon.svg": 41485,
	"./icons/archive-icon.svg": 9658,
	"./icons/arrow-down-circle-icon.svg": 70976,
	"./icons/arrow-down-icon.svg": 8520,
	"./icons/arrow-down-left-icon.svg": 14693,
	"./icons/arrow-down-right-icon.svg": 27379,
	"./icons/arrow-left-circle-icon.svg": 28103,
	"./icons/arrow-left-icon.svg": 81425,
	"./icons/arrow-right-circle-icon.svg": 29151,
	"./icons/arrow-right-icon.svg": 46209,
	"./icons/arrow-up-circle-icon.svg": 64048,
	"./icons/arrow-up-icon.svg": 39132,
	"./icons/arrow-up-left-icon.svg": 28435,
	"./icons/arrow-up-right-icon.svg": 94071,
	"./icons/at-sign-icon.svg": 95599,
	"./icons/award-icon.svg": 3010,
	"./icons/bar-chart-2-icon.svg": 34397,
	"./icons/bar-chart-icon.svg": 37115,
	"./icons/battery-charging-icon.svg": 83124,
	"./icons/battery-icon.svg": 52078,
	"./icons/bell-icon.svg": 5642,
	"./icons/bell-off-icon.svg": 79186,
	"./icons/bluetooth-icon.svg": 93269,
	"./icons/bold-icon.svg": 15749,
	"./icons/book-icon.svg": 49083,
	"./icons/book-open-icon.svg": 18279,
	"./icons/bookmark-icon.svg": 57537,
	"./icons/box-icon.svg": 61705,
	"./icons/briefcase-icon.svg": 50842,
	"./icons/calendar-icon.svg": 91710,
	"./icons/camera-icon.svg": 55764,
	"./icons/camera-off-icon.svg": 39459,
	"./icons/cast-icon.svg": 92316,
	"./icons/check-circle 2-icon.svg": 37459,
	"./icons/check-circle-icon.svg": 76190,
	"./icons/check-icon.svg": 99167,
	"./icons/check-square-icon.svg": 47685,
	"./icons/chevron-down-icon.svg": 41524,
	"./icons/chevron-left-icon.svg": 67972,
	"./icons/chevron-right-icon.svg": 63297,
	"./icons/chevron-up-icon.svg": 30488,
	"./icons/chevrons-down-icon.svg": 57938,
	"./icons/chevrons-left-icon.svg": 83156,
	"./icons/chevrons-right-icon.svg": 75525,
	"./icons/chevrons-up-icon.svg": 43278,
	"./icons/chrome-icon.svg": 10567,
	"./icons/circle-icon.svg": 72791,
	"./icons/clipboard-icon.svg": 202,
	"./icons/clock-icon.svg": 1992,
	"./icons/cloud-drizzle-icon.svg": 84828,
	"./icons/cloud-icon.svg": 41895,
	"./icons/cloud-lightning-icon.svg": 12069,
	"./icons/cloud-off-icon.svg": 45417,
	"./icons/cloud-rain-icon.svg": 35678,
	"./icons/cloud-snow-icon.svg": 59224,
	"./icons/code-icon.svg": 34832,
	"./icons/codepen-icon.svg": 27807,
	"./icons/codesandbox-icon.svg": 47270,
	"./icons/coffee-icon.svg": 26566,
	"./icons/columns-icon.svg": 14192,
	"./icons/command-icon.svg": 70357,
	"./icons/compass-icon.svg": 93382,
	"./icons/copy-icon.svg": 60110,
	"./icons/corner-down-left-icon.svg": 99614,
	"./icons/corner-down-right-icon.svg": 3512,
	"./icons/corner-left-down-icon.svg": 28983,
	"./icons/corner-left-up-icon.svg": 50451,
	"./icons/corner-right-down-icon.svg": 2960,
	"./icons/corner-right-up-icon.svg": 89878,
	"./icons/corner-up-left-icon.svg": 27227,
	"./icons/corner-up-right-icon.svg": 91107,
	"./icons/cpu-icon.svg": 51019,
	"./icons/credit-card-icon.svg": 34306,
	"./icons/crop-icon.svg": 77337,
	"./icons/crosshair-icon.svg": 7796,
	"./icons/data-table-icon.svg": 56768,
	"./icons/database-icon.svg": 30819,
	"./icons/delete-icon.svg": 96926,
	"./icons/disc-icon.svg": 99181,
	"./icons/divide-circle-icon.svg": 57815,
	"./icons/divide-icon.svg": 53143,
	"./icons/divide-square-icon.svg": 64603,
	"./icons/dollar-sign-icon.svg": 91761,
	"./icons/download-cloud-icon.svg": 32551,
	"./icons/download-icon.svg": 93549,
	"./icons/dribbble-icon.svg": 67181,
	"./icons/dropdown-icon.svg": 88879,
	"./icons/droplet-icon.svg": 97773,
	"./icons/edit-2-icon.svg": 40190,
	"./icons/edit-3-icon.svg": 69317,
	"./icons/edit-icon.svg": 10438,
	"./icons/external-link-icon.svg": 93005,
	"./icons/eye-icon.svg": 22381,
	"./icons/eye-off-icon.svg": 97474,
	"./icons/facebook-icon.svg": 98941,
	"./icons/fast-forward-icon.svg": 95125,
	"./icons/feather-icon.svg": 68182,
	"./icons/figma-icon.svg": 2377,
	"./icons/file-icon.svg": 68954,
	"./icons/file-minus-icon.svg": 99218,
	"./icons/file-plus-icon.svg": 58070,
	"./icons/file-text-icon.svg": 92840,
	"./icons/film-icon.svg": 23996,
	"./icons/filter-icon.svg": 68397,
	"./icons/flag-icon.svg": 63456,
	"./icons/folder-icon.svg": 88577,
	"./icons/folder-minus-icon.svg": 41511,
	"./icons/folder-plus-icon.svg": 43370,
	"./icons/framer-icon.svg": 35624,
	"./icons/frown-icon.svg": 55743,
	"./icons/gift-icon.svg": 61533,
	"./icons/git-branch-icon.svg": 4734,
	"./icons/git-commit-icon.svg": 91583,
	"./icons/git-merge-icon.svg": 58069,
	"./icons/git-pull-request-icon.svg": 46951,
	"./icons/github-icon.svg": 11643,
	"./icons/gitlab-icon.svg": 74846,
	"./icons/globe-icon.svg": 20869,
	"./icons/grid-icon.svg": 21354,
	"./icons/hard-drive-icon.svg": 81067,
	"./icons/hash-icon.svg": 97526,
	"./icons/headphones-icon.svg": 95270,
	"./icons/heart-icon.svg": 38136,
	"./icons/help-circle-icon.svg": 16334,
	"./icons/hexagon-icon.svg": 21485,
	"./icons/home-icon.svg": 77974,
	"./icons/image-icon.svg": 63749,
	"./icons/inbox-icon.svg": 1178,
	"./icons/info-icon.svg": 33309,
	"./icons/instagram-icon.svg": 49428,
	"./icons/italic-icon.svg": 21136,
	"./icons/key-icon.svg": 92090,
	"./icons/layers-icon.svg": 58376,
	"./icons/layout-icon.svg": 97123,
	"./icons/life-buoy-icon.svg": 33920,
	"./icons/link-2-icon.svg": 39659,
	"./icons/link-icon.svg": 19172,
	"./icons/linkedin-icon.svg": 79324,
	"./icons/list-icon.svg": 85706,
	"./icons/loader-icon.svg": 70801,
	"./icons/lock-icon.svg": 11033,
	"./icons/log-in-icon.svg": 1610,
	"./icons/log-out-icon.svg": 56607,
	"./icons/mail-icon.svg": 13338,
	"./icons/map-icon.svg": 18488,
	"./icons/map-pin-icon.svg": 52018,
	"./icons/maximize-2-icon.svg": 49633,
	"./icons/maximize-icon.svg": 81873,
	"./icons/meh-icon.svg": 8818,
	"./icons/menu-icon.svg": 18054,
	"./icons/message-circle-icon.svg": 2403,
	"./icons/message-square-icon.svg": 89745,
	"./icons/mic-icon.svg": 53615,
	"./icons/mic-off-icon.svg": 53971,
	"./icons/minimize-2-icon.svg": 57754,
	"./icons/minimize-icon.svg": 15517,
	"./icons/minus-circle-icon.svg": 29172,
	"./icons/minus-icon.svg": 58799,
	"./icons/minus-square-icon.svg": 22301,
	"./icons/monitor-icon.svg": 84358,
	"./icons/moon-icon.svg": 76122,
	"./icons/more-horizontal-icon.svg": 8400,
	"./icons/more-vertical-icon.svg": 40063,
	"./icons/mouse-pointer-icon.svg": 77241,
	"./icons/move-icon.svg": 94520,
	"./icons/music-icon.svg": 57774,
	"./icons/navigation-2-icon.svg": 42732,
	"./icons/navigation-icon.svg": 80676,
	"./icons/octagon-icon.svg": 27610,
	"./icons/package-icon.svg": 88876,
	"./icons/paperclip-icon.svg": 77638,
	"./icons/pause-circle-icon.svg": 668,
	"./icons/pause-icon.svg": 9680,
	"./icons/pen-tool-icon.svg": 42026,
	"./icons/percent-icon.svg": 96397,
	"./icons/phone-call-icon.svg": 75702,
	"./icons/phone-forwarded-icon.svg": 91448,
	"./icons/phone-icon.svg": 59910,
	"./icons/phone-incoming-icon.svg": 82086,
	"./icons/phone-missed-icon.svg": 37563,
	"./icons/phone-off-icon.svg": 74661,
	"./icons/phone-outgoing-icon.svg": 82199,
	"./icons/pie-chart-icon.svg": 69414,
	"./icons/play-circle-icon.svg": 90328,
	"./icons/play-fill-icon.svg": 6519,
	"./icons/play-icon.svg": 28008,
	"./icons/plus-circle-icon.svg": 75834,
	"./icons/plus-icon.svg": 15176,
	"./icons/plus-square-icon.svg": 7527,
	"./icons/pocket-icon.svg": 57990,
	"./icons/power-icon.svg": 82302,
	"./icons/printer-icon.svg": 93863,
	"./icons/radio-icon.svg": 14217,
	"./icons/refresh-ccw-icon.svg": 18976,
	"./icons/refresh-cw-icon.svg": 48915,
	"./icons/repeat-icon.svg": 84996,
	"./icons/rewind-icon.svg": 97857,
	"./icons/rotate-ccw-icon.svg": 134,
	"./icons/rotate-cw-icon.svg": 81276,
	"./icons/rss-icon.svg": 35360,
	"./icons/save-icon.svg": 94795,
	"./icons/scissors-icon.svg": 57172,
	"./icons/search-icon.svg": 94609,
	"./icons/send-icon.svg": 52505,
	"./icons/server-icon.svg": 4536,
	"./icons/settings-icon.svg": 13350,
	"./icons/share-2-icon.svg": 16576,
	"./icons/share-icon.svg": 6833,
	"./icons/shield-icon.svg": 3380,
	"./icons/shield-off-icon.svg": 45841,
	"./icons/shopping-bag-icon.svg": 78362,
	"./icons/shopping-cart-icon.svg": 90768,
	"./icons/shuffle-icon.svg": 21770,
	"./icons/sidebar-icon.svg": 85443,
	"./icons/skip-back-icon.svg": 35922,
	"./icons/skip-forward-icon.svg": 78198,
	"./icons/slack-icon.svg": 54642,
	"./icons/slash-icon.svg": 90806,
	"./icons/sliders-icon.svg": 43119,
	"./icons/smartphone-icon.svg": 14743,
	"./icons/smile-icon.svg": 28028,
	"./icons/speaker-icon.svg": 64848,
	"./icons/square-icon.svg": 47737,
	"./icons/star-icon.svg": 45340,
	"./icons/stop-circle-icon.svg": 72071,
	"./icons/sun-icon.svg": 15268,
	"./icons/sunrise-icon.svg": 62285,
	"./icons/sunset-icon.svg": 45767,
	"./icons/tablet-icon.svg": 1507,
	"./icons/tag-icon.svg": 33177,
	"./icons/target-icon.svg": 53085,
	"./icons/terminal-icon.svg": 39879,
	"./icons/thermometer-icon.svg": 87007,
	"./icons/thumbs-down-icon.svg": 28080,
	"./icons/thumbs-up-icon.svg": 65733,
	"./icons/toggle-left-icon.svg": 56742,
	"./icons/toggle-right-icon.svg": 84487,
	"./icons/tool-icon.svg": 85036,
	"./icons/trash-2-icon.svg": 58350,
	"./icons/trash-icon.svg": 1967,
	"./icons/trello-icon.svg": 79427,
	"./icons/trending-down-icon.svg": 67213,
	"./icons/trending-up-icon.svg": 66260,
	"./icons/triangle-icon.svg": 17912,
	"./icons/truck-icon.svg": 4059,
	"./icons/tv-icon.svg": 76424,
	"./icons/twitch-icon.svg": 45167,
	"./icons/twitter-icon.svg": 44880,
	"./icons/type-icon.svg": 53603,
	"./icons/umbrella-icon.svg": 63462,
	"./icons/underline-icon.svg": 64538,
	"./icons/unlock-icon.svg": 94717,
	"./icons/upload-cloud-icon.svg": 61841,
	"./icons/upload-icon.svg": 54445,
	"./icons/user-check-icon.svg": 60848,
	"./icons/user-icon.svg": 12096,
	"./icons/user-minus-icon.svg": 66936,
	"./icons/user-plus-icon.svg": 36768,
	"./icons/user-x-icon.svg": 30569,
	"./icons/users-icon.svg": 81057,
	"./icons/video-icon.svg": 55583,
	"./icons/video-off-icon.svg": 73398,
	"./icons/voicemail-icon.svg": 32699,
	"./icons/volume-1-icon.svg": 46024,
	"./icons/volume-2-icon.svg": 105,
	"./icons/volume-icon.svg": 38744,
	"./icons/volume-x-icon.svg": 21537,
	"./icons/watch-icon.svg": 75493,
	"./icons/wifi-icon.svg": 96060,
	"./icons/wifi-off-icon.svg": 68843,
	"./icons/wind-icon.svg": 55914,
	"./icons/x-circle-icon.svg": 13226,
	"./icons/x-icon.svg": 92759,
	"./icons/x-octagon-icon.svg": 36679,
	"./icons/x-square-icon.svg": 78423,
	"./icons/youtube-icon.svg": 72895,
	"./icons/zap-icon.svg": 12416,
	"./icons/zap-off-icon.svg": 72505,
	"./icons/zoom-in-icon.svg": 3788,
	"./icons/zoom-out-icon.svg": 60454,
	"./images/Screenshot - Database.jpg": 59238,
	"./images/Screenshot - Reports.jpg": 448,
	"./images/Screenshot - Survey.jpg": 23995,
	"./images/screenshot-app-survey-design.png": 18975,
	"./images/screenshot-checkout-survey.png": 16857,
	"./logo-airtable.png": 31025,
	"./logo-attribute-white.svg": 28237,
	"./logo-attribute.png": 11255,
	"./logo-attribute.svg": 74533,
	"./logo-google-sheets.png": 81440,
	"./logo-klaviyo.jpg": 18085,
	"./logo-klaviyo.png": 33939,
	"./logo-recharge.png": 20518,
	"./logo-shopify.jpg": 7186,
	"./logo-shopify.png": 54873,
	"./logo.png": 66949,
	"./screenshot-reports.jpg": 68995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;